type SekeletonTableProps = {
  columns: number
  rows?: number
}

export const TableSekeleton = ({ columns, rows = 10 }: SekeletonTableProps) => {
  const sekeletonArray = Array.from({ length: rows }, (_, i) => i)
  return (
    <>
      {sekeletonArray.map((item) => (
        <tr key={item}>
          {Array.from(
            {
              length: columns,
            },
            (_, i) => i
          ).map((elm) => (
            <td key={elm} className='animate-pulse px-6 py-1'>
              <div className='my-4 h-full w-full bg-slate-200 p-2' />
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}
